<template>
  <div class="container">
    <van-list
      v-model="loading"
      :immediate-check="true"
      :finished="finished"
      finished-text="没有更多啦"
      @load="load_more"
    >
      <van-field
        v-for="(item, index) in list"
        :key="index"
        :value="item.title"
        readonly
        right-icon="arrow"
        @click="urlchange(item.id, item.type, item.link)"
      />
    </van-list>
  </div>
</template>
<script>
export default {
  name: "fybgt",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
    };
  },
  created() {
    this.init();
  },
  methods: {
    urlchange(id, type, link) {
      if (type == 1) {
        this.$router.push({
          name: "policydetail",
          query: {
            id: id,
          },
        });
      } else {
        window.location.href = link;
      }
    },
    init() {
      this.$axios({
        method: "post",
        url: "/api/policy/list",
        data: this.qs.stringify({
          mod: 5,
        }),
      }).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data.list;
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    load_more() {
      this.page += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/policy/list",
            data: that.qs.stringify({
              token: sessionStorage.getItem("wmtoken"),
              page: that.page,
              mod: 5,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.finished = true;
            } else {
              that.finished = false;
            }
          });
      }, 500);
    },
  },
};
</script>
<style scoped>
.van-field /deep/ .van-field__control {
  text-overflow: ellipsis;
}
.container {
  min-height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/components/fybgt.vue